export default "__VITE_ASSET__BlJ8uLh8__"